<template>
	<el-card shadow="never" class="aui-card--fill">
    <editQyyhUser v-if="isAddByAgent == 1" :userId="userId"></editQyyhUser>
		<qyyhUserOld ref="qyyhUserOld" v-else></qyyhUserOld>
	</el-card>
</template>

<script>
import editQyyhUser from './edit-qyyh-user'
import qyyhUserOld from './qyyhUserOld'
import debounce from 'lodash/debounce'
import Cookies from 'js-cookie'

export default {
  components: {
    editQyyhUser,
    qyyhUserOld
  },
  data () {
    return {
      userId:'',
      isAddByAgent:null
    }
  },
  computed: {
  },

  created () {
    this.getInfo()
  },
  methods: {
    getInfo(){
      this.$http.get(`/sys/user/info`).then(({ data: res }) => {
        console.log(res.data.isAddByAgent)
        this.userId = res.data.id
        this.isAddByAgent = res.data.isAddByAgent
      })
    }
  }
}
</script>
<style>
.delUploadPic{
  color: #F56C6C;
  cursor: pointer;
  float: right;
}
</style>